import { refinementList, panel } from 'instantsearch.js/es/widgets';

export const refinementListWithPanel = header =>
  panel({
    templates: {
      header: `<h2 class="archive__filter-label">${header}</h2>`,
    },
    hidden(options) {
      return options.items.length === 0;
    },
  })(refinementList);
